// A distance in both units, no imports so the frontend tests can compile it.
// Source value in km; `unit` is the resolved display unit (km or mi) and goes
// first: "122 mi (196 km)" or "196 km (122 mi)". Whole numbers from 10 up, one
// decimal below 10 (`digits` overrides). Null, undefined or NaN gives the dash.

export const KM_PER_MILE = 1.60934;

export function distanceBoth(
  kmValue: number | null | undefined,
  unit: "km" | "mi",
  digits?: number,
  dash = "\u2014",
): string {
  if (kmValue === null || kmValue === undefined || !Number.isFinite(kmValue)) return dash;
  const one = (v: number, u: string): string => {
    const dg = digits ?? (Math.abs(v) < 10 ? 1 : 0);
    return `${v.toLocaleString("en-US", { minimumFractionDigits: dg, maximumFractionDigits: dg })} ${u}`;
  };
  const km = one(kmValue, "km");
  const mi = one(kmValue / KM_PER_MILE, "mi");
  return unit === "mi" ? `${mi} (${km})` : `${km} (${mi})`;
}
